// Rutas que son "pantallas-tab" de la barra de navegación inferior en mobile.
//
// La barra SOLO se muestra en estas rutas, y el header mobile oculta el botón
// "back" en ellas (son raíces de navegación: se cambian con las tabs, no con
// back).
//
// El landing de Estudio (selección de productos) muestra la barra en su estado
// raíz; cuando el usuario selecciona productos aparece su CTA de generar y la
// página oculta la barra vía `mobileHideBottomNav` (modo tarea).
export const MOBILE_BOTTOM_NAV_PATHS = [
  "/interfaz-v2",
  "/modos",
  "/mi-marca",
  "/redes-sociales/imagenes",
  "/redes-sociales/crear-anuncio/seleccionar-productos",
];
